import moment from 'moment-timezone';
import async from 'async';
import * as _ from 'underscore';
import swal from 'sweetalert2';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as tus from "tus-js-client";
import * as NProgress from 'nprogress';
import { connect, Provider } from 'react-redux';
import { combineReducers, createStore } from 'redux';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import uuidv4 from 'uuidv4';
import * as mqtt from 'mqtt';
import $ from "jquery";
import * as Highcharts from "highcharts";
import HighchartsReact from 'highcharts-react-official';
// import { AgGridReact } from 'ag-grid-react';
// import { heart, share } from 'ionicons/icons';
import ColumnSelect from 'react-column-select'
import StepWizard from "react-step-wizard";
import Draggable, { DraggableCore } from 'react-draggable';
import { Stepper, Step } from "react-form-stepper";
import { fetchEventSource } from "@microsoft/fetch-event-source";
import { encode as HTMLEncode } from "he";
import markdownIt from "markdown-it";
import hljs from "highlight.js";
// import OT from '@opentok/client';
import DailyIframe from '@daily-co/daily-js';
import * as dco from '@daily-co/daily-react';
import { RecoilRoot } from 'recoil';
import { loadStripe } from '@stripe/stripe-js';
import { useSelector, useDispatch } from 'react-redux';
import * as antd from 'antd';
import * as antv from "@antv/g6";
import * as antdPlots from '@ant-design/plots';
import * as antdIcons from '@ant-design/icons';
import http from './interceptors/httpInterceptor';
import MonacoEditor from 'react-monaco-editor';
//System redcuers
import counter from "./reducers/counter";
import appState from "./reducers/appState";
import login from "./reducers/login";
import brokerStatus from "./reducers/brokerStatus";
import brokerLogs from "./reducers/brokerLogs";

import Timeline, {
    TimelineMarkers,
    TodayMarker,
    CustomMarker,
    CursorMarker,
} from 'react-calendar-timeline';
import CheckboxTree from 'react-checkbox-tree';

export default angular.module('obto.data.service', [])
    .factory('pqs', function pqsFactory() {
        return function (str) {
            return (str || document.location.search).replace(/(^\?)/, '').split("&").map(function (n) {
                return n = n.split("="), this[n[0]] = n[1], this;
            }.bind({}))[0];
        };
    })
    .factory('Page', function () {
        var title = 'default';
        return {
            title: function () {
                return title;
            },
            setTitle: function (newTitle) {
                title = newTitle;
            }
        };
    })
    .factory('_', function () {
        return _;
    })
    .factory('async', function () {
        return async;
    })
    .factory('swal', function () {
        return swal;
    })
    .factory('moment', ['$rootScope', function ($rootScope) {
        moment.tz.setDefault($rootScope.timezone);
        return moment;
    }])
    .factory('beforeUnload', ['$rootScope', '$window', '$location', 'OB', function ($rootScope, $window, $location, OB) {

        // Events are broadcast outside the Scope Lifecycle
        const bodySelector = $('body');
        let targetPages = ['ob-connect', 'sofos-notice-board', 'imitate', 'ob-domains', 'switchdomain', 'changesets', 'changeset'];
        const deregister1 = $rootScope.$on('event:titlechanged', function (e, d) {

            if (targetPages.indexOf(d) === -1) {
                $window.document.title = d.replace(/\w\S*/g, function (txt) {
                    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                });
            }
        });

        const deregister2 = $rootScope.$on('$routeChangeSuccess', function () {
            // Set to default (show) state left and top menu, remove single page classes
            // bodySelector.removeClass('single-page single-page-inverse');
            $rootScope.hideLeftMenu = false;
            $rootScope.hideTopMenu = false;
            $rootScope.showFooter = true;

            $('.left-menu-list-active').removeClass('left-menu-list-active');
            $('nav.left-menu .left-menu-list-root .left-menu-link').each(function () {
                if ($(this).attr('href') === '#' + $location.path()) {
                    $(this).closest('.left-menu-list-root > li').addClass('left-menu-list-active');
                }
            });

            setTimeout(() => {
                bodySelector.removeClass('initial-hide');
                bodySelector.removeClass('cui-page-loading-state');
                // NProgress.done();
            }, 400);

        });

        /**
         * On 'event:loginRequest' send credentials to the server.
         **/

        const deregister3 = $rootScope.$on('event:loginRequest', function (event, user) {
            const authPayload = { username: user.user_name, password: user.user_password };
            if (user.hasOwnProperty('gToken')) {
                authPayload.gToken = user.gToken;
            }
            OB.auth($.param(authPayload));
        });

        const deregister4 = $rootScope.$on('event:logoutConfirmed', () => {
            try {
                console.log("Preparing Terminating worker....");
            } catch (e) {

            }
        });

        $window.onbeforeunload = function (e) {
            console.log('Unloading window...');
            deregister1();
            deregister2();
            deregister3();
            deregister4();
            var confirmation = {};
            var event = $rootScope.$broadcast('event:onBeforeUnload', confirmation);
            if (event.defaultPrevented) {
                return confirmation.message;
            }
        };

        $window.onunload = function () {
            $rootScope.$broadcast('event:onUnload');
        };

        return {};
    }])
    .factory('pageService', ['$http', '$log', '$q', 'async', function ($http, $log, $q, async) {

        let defer = $q.defer();

        function getGridModelPromise(collection) {
            // var data = "";
            $http.get('/o/' + collection + '/list').success(function (data) {
                defer.resolve(data);

            }).error(function () {

                $log.log('Error');
                //callback([]);
                defer.reject();

            });
        }

        function getGridModelv2(collection, project, filters, callback) {
            let deferred = $q.defer();
            let _responseChangeFunctions = {}, _responseModel = {}, _responseLoadFunctions = {}, _response = {},
                _responseConfig = {};
            let onChangeFunctions = (c) => {
                $http.get('/o/' + collection + '/listv2?project=' + project).then(function (response) {
                    //console.log(data);
                    if (response.status === 200) {
                        _responseChangeFunctions = response.data;
                    }
                    c(null, 1);
                });
            };
            let onLoadFunctions = (c) => {
                $http.get('/o/' + collection + '/listv2?project=' + project).then(function (response) {
                    //console.log(data);
                    if (response.status === 200) {
                        _responseLoadFunctions = response.data;
                    }
                    c(null, 2);
                });
            };

            let gridConfig = (c) => {
                $http.get(`/o/recs/pltf_collection_config?nd=${new Date().getTime()}&stream=true&oquery=collection=${collection}&project=${project}&filters=${filters}`).then(function (response) {
                    if (response.status === 200 && response.data.length > 0) {
                        _responseConfig = response.data[0];
                    }
                    c(null, 1);
                });
            };

            let gridModel = (c) => {
                $http.get('/o/' + collection + '/listv2?project=' + project + '&filters=' + filters).then(function (response) {
                    //console.log(data);
                    if (response.status === 200) {
                        _responseModel = response.data;
                    }
                    c(null, 2);
                });
            };
            async.parallel([/*onChangeFunctions, onLoadFunctions, */gridModel, gridConfig], (err, res) => {
                _response = _responseModel;
                _response.onChangeFunctions = _responseChangeFunctions;
                _response.onLoadFunctions = _responseLoadFunctions;
                _response.config = _responseConfig;
                deferred.resolve(this);
                callback(_response);
            });

            return deferred.promise;

        }

        function getGridModel(collection, project, filters, callback) {
            let _responseChangeFunctions = {}, _responseModel = {}, _responseLoadFunctions = {}, _response = {},
                _responseConfig = {};
            let onChangeFunctions = (c) => {
                $http.get('/o/' + collection + '/list?project=' + project).then(function (response) {
                    //console.log(data);
                    if (response.status === 200) {
                        _responseChangeFunctions = response.data;
                    }
                    c(null, 1);
                });
            };
            let onLoadFunctions = (c) => {
                $http.get('/o/' + collection + '/list?project=' + project).then(function (response) {
                    //console.log(data);
                    if (response.status === 200) {
                        _responseLoadFunctions = response.data;
                    }
                    c(null, 2);
                });
            };

            let gridConfig = (c) => {
                $http.get(`/o/recs/pltf_collection_config?nd=${new Date().getTime()}&stream=true&oquery=collection=${collection}&project=${project}&filters=${filters}`).then(function (response) {
                    if (response.status === 200 && response.data.length > 0) {
                        _responseConfig = response.data[0];
                    }
                    c(null, 1);
                });
            };

            let gridModel = (c) => {
                $http.get('/o/' + collection + '/list?project=' + project + '&filters=' + filters).then(function (response) {
                    //console.log(data);
                    if (response.status === 200) {
                        _responseModel = response.data;
                    }
                    c(null, 2);
                });
            };
            async.parallel([/*onChangeFunctions, onLoadFunctions, */gridModel, gridConfig], (err, res) => {
                _response = _responseModel;
                _response.onChangeFunctions = _responseChangeFunctions;
                _response.onLoadFunctions = _responseLoadFunctions;
                _response.config = _responseConfig;

                callback(_response);
            });

        }

        function getPageConfig(pageName) {

            $http.get('/o/recs/pltf_dashboard_page?_search=true&nd=' + Date.now() + '&rows=10&page=1&sidx=_id&sord=desc&name=' + pageName).then(function (response) {

                if (response.status === 200) {
                    defer.resolve(response.data);
                } else {
                    $log.log('Error');
                    defer.reject();
                }
            });

        }

        function getById(id, callback) {

            if (id !== "")
                $http.get('/o/recs/pltf_visualization?_search=true&nd=' + Date.now() + '&rows=10&page=1&sidx=_id&sord=desc&_id=' + id).then(function (response) {

                    if (response.status === 200) {
                        callback(response.data);
                    } else {
                        $log.log('Error');
                        callback([]);
                    }
                });

        }

        function getData(name, callback, opts) {
            $http.get('/o/getchartdata/' + name + '?' + opts).then(function (response) {

                if (response.status === 200) {
                    callback(response.data);
                } else {
                    $log.log('Error');
                    callback([]);
                }

            });

        }

        return {
            get: function (pageName) {
                getPageConfig(pageName);
                return defer.promise;
            },
            getbyid: function (id, callback) {
                getById(id, callback);
                //return defer.promise;
            },
            getbydata: function (name, callback, opts) {
                getData(name, callback, opts);
                //return defer.promise;
            },
            getgridmodelpromise: function (collection) {
                getGridModelPromise(collection);
                return defer.promise;
            },
            getgridmodel: function (collection, project, filters, callback) {
                getGridModel(collection, project, filters, callback);
            },
            getgridmodelv2: function (collection, project, filters, callback) {
                return getGridModelv2(collection, project, filters, callback);
            }
        };
    }])
    .service('pageServicev2', ['$http', '$log', '$q', 'async', function ($http, $log, $q, async) {

        this.getGridModelv2 = (collection, project, filters, callback) => {

            let deferred = $q.defer();

            if (typeof collection === 'undefined') {
                return deferred.resolve([]);
            }
            let _responseChangeFunctions = {}, _responseModel = {}, _responseLoadFunctions = {}, _response = {},
                _responseConfig = {};
            let onChangeFunctions = (c) => {
                $http.get('/o/' + collection + '/listv2?project=' + project).then(function (response) {
                    //console.log(data);
                    if (response.status === 200) {
                        _responseChangeFunctions = response.data;
                    }
                    c(null, 1);
                });
            };
            let onLoadFunctions = (c) => {
                $http.get('/o/' + collection + '/listv2?project=' + project).then(function (response) {
                    //console.log(data);
                    if (response.status === 200) {
                        _responseLoadFunctions = response.data;
                    }
                    c(null, 2);
                });
            };

            let gridConfig = (c) => {
                $http.get(`/o/recs/pltf_collection_config?nd=${new Date().getTime()}&stream=true&oquery=collection=${collection}&project=${project}&filters=${filters}`).then(function (response) {
                    if (response.status === 200 && response.data.length > 0) {
                        _responseConfig = response.data[0];
                    }
                    c(null, 1);
                });
            };

            let gridModel = (c) => {
                $http.get('/o/' + collection + '/listv2?nd=${new Date().getTime()}&project=' + project + '&filters=' + filters).then(function (response) {
                    //console.log(data);
                    if (response.status === 200) {
                        _responseModel = response.data;
                    }
                    c(null, 2);
                });
            };

            async.parallel([/*onChangeFunctions, onLoadFunctions, */gridModel, gridConfig], (err, res) => {
                _response = _responseModel;
                _response.onChangeFunctions = _responseChangeFunctions;
                _response.onLoadFunctions = _responseLoadFunctions;
                _response.config = _responseConfig;
                deferred.resolve(_response);
                // callback(_response);
            });
            return deferred.promise;
        };
    }])
    .factory('$localstorage', ['$window', function ($window) {
        return {
            set: function (key, value) {
                $window.localStorage.setItem(key, value);//[key] = value;
            },
            clear: function () {
                $window.localStorage.clear();
            },
            get: function (key, defaultValue) {
                return $window.localStorage.getItem(key) || defaultValue;//[key] || defaultValue;
            },
            getTs: function (key) {
                return $window.localStorage.getItem(key) || null;
            },
            setObject: function (key, value) {
                $window.localStorage.setItem(key, JSON.stringify(value));
            },
            getObject: function (key) {
                if (!$window.localStorage.getItem(key) || typeof $window.localStorage.getItem(key) === "undefined") {
                    return {};
                }
                // console.log($window.localStorage.getItem(key));
                try {
                    return JSON.parse($window.localStorage.getItem(key));
                } catch (e) {
                    return {};
                }

            },
            remove: function (key) {
                $window.localStorage.removeItem(key);
            }
        };
    }])
    .service('OB', ['$window', '$http', '$rootScope', '$localstorage', '$log', '$location', '$ngRedux', 'ScriptLoader', function ($window, $http, $rootScope, $localstorage, $log, $location, $ngRedux, ScriptLoader) {

        const config = {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        };

        this.getInitials = function (name) {

            var canvas = document.createElement('canvas');
            canvas.style.display = 'none';
            canvas.width = '32';
            canvas.height = '32';
            document.body.appendChild(canvas);
            var context = canvas.getContext('2d');
            context.fillStyle = "#7755fe";
            context.fillRect(0, 0, canvas.width, canvas.height);
            context.font = "16px Arial";
            context.fillStyle = "#fff";
            var first, last;
            if (name && name.first && name.first !== "") {
                first = name.first[0];
                last = name.last && name.last !== "" ? name.last[0] : null;
                if (last) {
                    var initials = first + last;
                    context.fillText(initials.toUpperCase(), 5, 23);
                } else {
                    var initials = first;
                    context.fillText(initials.toUpperCase(), 10, 23);
                }
                var data = canvas.toDataURL();
                document.body.removeChild(canvas);
                return data;
            } else {
                return false;
            }
        };

        this.saveConfiguration = function (response) {
            const data = response.data;
            $window.sessionStorage.token = data.token;
            $rootScope.globaloprops = data.globaloprops;
            $rootScope.oprops = data.oprops;
            _.extend($rootScope.globalAttributes, $rootScope.globaloprops, $rootScope.oprops);

            $rootScope.connectionlost = false;
            $rootScope.socketNamespace = data.socketNamespace;
            $rootScope.token = data.token;
            $rootScope.display_picture_url = "https://res.cloudinary.com/www-obto-co/image/upload/h_100,w_100/v1612653291/DEV/USERS/599dd0390eb8bb51bb3ec0f6.png";
            $rootScope.isEdu = data.isEdu;
            $rootScope.ob.isEdu = data.isEdu;
            $rootScope.ob.token = data.token;
            $rootScope.ob.red_token = data.red_token;
            $rootScope.ob.logourl = $rootScope.globalAttributes['co.obto.customer.logourl'] || "https://static.obto.co/ob/assets/dist/2.0/img/sofos-logo-312x312.png";
            $rootScope.ob.socketEnabled = $rootScope.globalAttributes['co.obto.socket.enabled'] || false;
            $rootScope.ob.menuTop = $rootScope.globalAttributes['co.obto.menu.top'];
            $rootScope.ob.socketSecured = data.isSecure;

            _.extend($rootScope.ob.user, data.user);
            _.extend($rootScope.user, data.user);
            $rootScope.ob.user.atts = $rootScope.user.atts;
            $rootScope.domain = $rootScope.ob.domain = data.domain;
            $rootScope.userName = $rootScope.ob.user.username = $rootScope.user.user_name;
            $rootScope.userfullname = $rootScope.ob.user.userfullname = $rootScope.user.name;
            $rootScope.userid = $rootScope.ob.user.userid = $rootScope.user._id;
            $rootScope.timezone = $rootScope.ob.user.timezone = $rootScope.user.time_zone;
            $rootScope.myClass = $rootScope.ob.user.myClass = $rootScope.user.class;
            $rootScope.homepage = $rootScope.ob.user.homepage = _.isUndefined($rootScope.user.homepage) ? "" : $rootScope.user.homepage;
            $rootScope.timezoneoffset = $rootScope.ob.user.timezoneoffset = moment.tz($rootScope.timezone).format('Z');

            try {
                $localstorage.setObject("ob.props", $rootScope.globalAttributes);
                if (!$localstorage.get("oversion")) {
                    console.log("Global version will now be set");
                    $localstorage.set("oversion", $rootScope.oversion);
                }
            } catch (e) {

            }

            try {
                this.setUserProfile();
            } catch (e) {

            }

        };

        this.auth = function (payload) {
            $http.post('/auth', payload, config).then((response) => {
                if (response.data.success) {
                    $rootScope.ob.isLoginOpen = false;
                    this.saveConfiguration(response);
                    $localstorage.setObject("ob", $rootScope.ob);
                    $localstorage.set("wsToken", $rootScope.ob.token);
                    $localstorage.set("auth-tokens", JSON.stringify({
                        "access_token": $rootScope.ob.token,
                        "expires_in": 604800,
                        "token_type": "Bearer"
                    }));
                    $localstorage.set("auth-tokens-flows", JSON.stringify({
                        "access_token": $rootScope.ob.token,
                        "expires_in": 604800,
                        "token_type": "Bearer"
                    }));

                    this.setSession($rootScope.globalAttributes['co.obto.edu.current.session']);
                    ScriptLoader.init().then(() => {
                        $rootScope.hideTopMenu = false;
                        $rootScope.showmodal = false;
                        $rootScope.loadComplete = true;
                        $rootScope.prepareApp = false;
                        $rootScope.$broadcast('event:loginConfirmed');
                        if ($rootScope.redirectTo !== "/" && $rootScope.redirectTo.indexOf('login.bto') === -1) {
                            $location.path($rootScope.redirectTo);
                        } else {
                            $location.path('/');
                        }
                        NProgress.done();
                    });
                } else {
                    $localstorage.remove('__ot');
                    $location.path('/login.bto');
                    $ngRedux.dispatch({
                        type: 'LOGIN',
                        payload: {
                            "loginStatus": -1,
                            "socketStatus": {
                                "status": "not_ready"
                            }
                        }
                    });
                    NProgress.done();
                }
            });
        };

        this.redAuth = (payload) => {
            var data = `client_id=node-red-admin&grant_type=password&scope=*&username=${payload.username}&password=${payload.password}`;

            var xhr = new XMLHttpRequest();
            xhr.withCredentials = true;

            xhr.addEventListener("readystatechange", function () {
                if (this.readyState === 4) {
                    console.log(this.responseText);
                    $localstorage.setObject("auth-tokens", JSON.parse(this.responseText));
                }
            });

            xhr.open("POST", "/red/auth/token");
            xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
            xhr.setRequestHeader("User-Agent", "PostmanRuntime/7.16.3");
            xhr.setRequestHeader("Accept", "*/*");
            xhr.setRequestHeader("Cache-Control", "no-cache");
            xhr.setRequestHeader("Postman-Token", "733087ec-6518-4ec1-b04b-f67f185b6158,babe46ff-ef04-412b-a5b1-75975ddc982a");
            xhr.setRequestHeader("Host", "localhost:43000");
            xhr.setRequestHeader("Accept-Encoding", "gzip, deflate");
            xhr.setRequestHeader("Content-Length", "87");
            xhr.setRequestHeader("Connection", "keep-alive");
            xhr.setRequestHeader("cache-control", "no-cache");
            xhr.send(data);
        };

        this.ping = function () {
            $http.get('/o/ping?v=' + new Date().getTime()).then((response) => {

                if (response.data.success) {
                    // ScriptLoader.init().then(() => {
                    $rootScope.ob.isLoginOpen = false;
                    this.saveConfiguration(response);
                    $rootScope.hideTopMenu = false;
                    $localstorage.setObject("ob", $rootScope.ob);
                    $localstorage.set("wsToken", $rootScope.ob.token);
                    $localstorage.set("auth-tokens", JSON.stringify({
                        "access_token": $rootScope.ob.token,
                        "expires_in": 604800,
                        "token_type": "Bearer"
                    }));
                    if (!$rootScope.loadComplete && $localstorage.getObject("ob").token) {
                        $rootScope.loadComplete = true;
                    }

                    const path = $location.path();
                    if (path.indexOf("login.bto") > -1) {
                        $location.path("/");
                    }

                    const bodySelector = $('body');
                    bodySelector.removeClass('initial-hide');
                    console.log('event:loggedIn');
                    $rootScope.$broadcast('event:loggedIn');
                    $ngRedux.dispatch({
                        type: 'LOGIN',
                        payload: {
                            "loginStatus": 0
                        }
                    });
                }
            });
        };

        this.loadReducers = () => {
            let reducers = {
                counter,
                appState,
                login
            };

            $http.get('/fetch_reducers.bto').then((response) => {

                if (response.status === 200) {
                    // reducers = {};
                    async.eachSeries(response.data, (cl, cb) => {
                        if (!cl.compiled) {
                            return cb();
                        }
                        try {
                            $localstorage.set("reducer-" + cl.name, cl.compiled.code);
                            reducers[cl.name] = new Function(`try { ${cl.compiled.code} } catch(e){ throw e;}`)();
                        } catch (e) {
                            console.log('Faulty Reducer..', cl.name);
                            console.error(e.message);
                        }
                        cb();
                    }, (err) => {
                        const rootReducer = combineReducers(reducers);
                        $ngRedux.replaceReducer(rootReducer);
                    });
                } else {
                    console.log('Cannot replacing reducers!');
                }
            }).catch((err) => {
                console.log('Error fetching/replacing reducers!' + JSON.stringify(err));
            });
        };

        this.init = function () {

            $rootScope.requests401 = [];
            $rootScope.globalAttributes = {};
            $rootScope.globaloprops = {};//globaloprops;
            $rootScope.oprops = {};//oprops;
            $rootScope.oversion = window.oversion;
            $rootScope.user = {};//ouser;
            $rootScope.connectionlost = false;
            $rootScope._lurl = 'SOMTHING';
            $rootScope._csrf = 'SOMTHING';
            $rootScope.socketNamespace = 'SOMTHING';
            $rootScope.domain = 'dev';
            $rootScope.token = void (0);
            $rootScope.redirectTo = "/login.bto";
            $rootScope.socketReConnectionTO = null;
            $rootScope.notif = {};
            $rootScope.notif.systemmessage = "";
            $rootScope.notif.newmessagestyle = {
                "margin-bottom": "0px",
                "color": "#FFFFFF",
                "background": "#448aff",
                "z-index": "999",
                "font-weight": "700",
                "position": "relative"
            };
            $rootScope.myChatSettings = {
                from_username: "",
                picture: ""
            };
            $rootScope.ob = {};
            $rootScope.ob.access = {};
            $rootScope.ob.imitation = false;
            $rootScope.ob.imitating_user = null;
            $rootScope.ob.imitating_initiator = null;
            $rootScope.ob.imitating_user_token = null;
            $rootScope.ob.access.upload = false;
            $rootScope.ob.access.download = false;
            $rootScope.ob.access.chat = false;
            $rootScope.ob.access.delete = false;
            $rootScope.ob.access.view_schema = false;
            $rootScope.ob.user = {};
            $rootScope.ob.domain = undefined;
            $rootScope.ob.menuTop = $rootScope.globalAttributes['co.obto.menu.top'];
            $rootScope.ob.chatusers = [];
            $rootScope.ob.token = void (0);
            $rootScope.ob.requests401 = [];
            $rootScope.ob.isLoginOpen = true;
            $rootScope.ob.logourl = "";
            $rootScope.ob.copyrightNotice = "";
            $rootScope.ob.privacyPolicyLink = "";
            $rootScope.ob.termsPolicyLink = "";
            $rootScope.ob.securityPolicyLink = "";
            $rootScope.ob.privacyTosAcceptance = "";
            $rootScope.ob.isEdu = false;
            $rootScope.ob.conversations = {};
            $rootScope.ob.productionName = "Platform";
            $rootScope.ob.conversationAlerts = {};
            $rootScope.ob.socketEnabled = false;
            $rootScope.ob.activeconversation = null;
            $rootScope.ob.otherusertyping = false;
            $rootScope.ob.session = "";
            $rootScope.ob.sessionLabel = "Session";
            $rootScope.ob.language = "en";
            $rootScope.ob.languageLabel = "English";
            $rootScope.ob.eduCollections = [
                "transport_schedule",
                "route",
                "transport",
                "admission",
                "registration",
                "notification",
                "homework",
                "result",
                "cosresult",
                "sms",
                "topic",
                "payment",
                "fee_schedule",
                "fee",
                "fee_concession",
                "class",
                "subject",
                "student_subject",
                "class_schedule",
                "cosquestion",
                "grade_scale",
                "library_transaction",
                "attendance",
                "health",
                "groupconfig",
                "calendar_event",
                "leave_request",
                "transfer_certificate",
                "intrim_mark",
                "report_card",
                "sequence",
                "reportcard_condition",
                "reportcard_scripts",
                "session_preparation_task",
                "class_promotion"
            ];
            $rootScope.ob.languages = {
                "en": "English",
                "fr": "France",
                "ar": "Arabic",
                "es": "Spanish",
                "hi": "Hindi",
                "gr": "German",
                "pu": "Punjabi",
                "tl": "Tamil"
            };
            $rootScope.ob.alertCount = 0;
            $rootScope.ob.alert = false;

            $rootScope.showmodal = false;
            $rootScope.prepareApp = true;
            $rootScope.loginModal = null;
            $rootScope.blur = null;
            $rootScope.loginFailed = false;
            $rootScope.loadComplete = false;

            if ($localstorage.getObject("ob").imitation) {
                $rootScope.ob.imitation = true;
                $rootScope.ob.imitating_user = $localstorage.getObject("ob").imitating_user;
                $rootScope.ob.imitating_initiator = $localstorage.getObject("ob").imitating_initiator;
                $rootScope.ob.imitating_initiator_token = $localstorage.getObject("ob").imitating_initiator_token;
                $log.info("Imitation Active");
                setTimeout(() => {
                    $rootScope.$emit("event:imitationActive", {});
                }, 2500);

            }
        };

        this.setUserProfile = () => {

            const existingUser = ($localstorage.getObject("ob")) ? $localstorage.getObject("ob").user : 'notfound';
            const olderUser = ($rootScope.ob) ? $rootScope.ob.user : 'notfound';
            let imgSrc = "data:image/png;base64,";

            $http.get("/o/userprofilepicture.bto/", {
                cache: true
            }).then((response) => {
                const getInitialsPayload = { first: "", last: "" };
                const name = ($rootScope.user.name) ? $rootScope.user.name.split() : ["OBTO", "User"];
                getInitialsPayload.first = name[0];
                getInitialsPayload.last = (name[1]) ? name[1] : "";

                if (response.status === 200) {
                    if (Object.keys(response.data).length === 0) {
                        imgSrc += "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";
                        $rootScope.user.display_picture_url = this.getInitials(getInitialsPayload);
                    } else {
                        imgSrc += window.btoa(response.data.display_picture);
                        if (response.data.display_picture_url) {
                            $rootScope.user.display_picture_url = response.data.display_picture_url;
                        } else {
                            $rootScope.user.display_picture_url = this.getInitials(getInitialsPayload);
                        }
                    }
                } else {
                    $rootScope.user.display_picture_url = this.getInitials(getInitialsPayload);
                    imgSrc += "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";
                }

                // console.log('$rootScope.user.display_picture_url', $rootScope.user.display_picture_url);
                $localstorage.setObject("obto.user_name", {
                    user_name: existingUser.user_name
                });

                $localstorage.set('newui', $rootScope.ob.user.newui);
                $rootScope.user.display_picture = imgSrc;
                $rootScope.myChatSettings.picture = imgSrc;
                // Reconsider this....
                // $localstorage.setObject("obto.user_image", {
                //     user_image: imgSrc
                // });


            });
        };

        this.imitate = (imitating_user) => {
            const payload = $.param({ userid: imitating_user });//$.param({username: imitating_user, password: 'Tn986bacd'});
            $http.post('/o/imitate.bto', payload, config).then((response) => {
                if (response.data.success) {
                    $rootScope.ob.imitation = true;
                    $rootScope.ob.imitating_user = imitating_user;
                    $rootScope.ob.imitating_initiator = $localstorage.getObject("ob").user.userid;
                    $rootScope.ob.imitating_initiator_token = $localstorage.getObject("ob").token;
                    this.saveConfiguration(response);
                    $localstorage.setObject("ob", $rootScope.ob);
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                }
            });
        };

        this.end_imitation = () => {
            let payload = $.param({ userid: $rootScope.ob.imitating_initiator });
            $http.post('/o/imitate.bto', payload, config).then((response) => {

                if (response.data.success) {
                    $rootScope.ob.imitation = false;
                    $rootScope.ob.imitating_user = null;
                    $rootScope.ob.imitating_initiator = null;
                    $rootScope.ob.imitating_initiator_token = null;
                    this.saveConfiguration(response);
                    $localstorage.setObject("ob", $rootScope.ob);
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                }

            });
        };

        this.setDomain = (domain) => {

            let DOMAIN = $localstorage.getObject("ob").domain || $rootScope.ob.domain;
            if (domain) {
                DOMAIN = domain;
            }
            $rootScope.domain = DOMAIN;
            $rootScope.ob.domain = DOMAIN;

            let NEW_GLOBAL_SETTINGS = $localstorage.getObject("ob");
            NEW_GLOBAL_SETTINGS.domain = DOMAIN;

            $localstorage.setObject("ob", NEW_GLOBAL_SETTINGS);
            $log.info("Domain switched.");

            setTimeout(() => {
                $window.location.reload(true);
            }, 500);
        };

        this.setSession = (session) => {

            let SESSION = ($localstorage.getObject("ob.edu") && $localstorage.getObject("ob.edu").session) ? $localstorage.getObject("ob.edu").session : $rootScope.ob.session;
            if (session) {
                SESSION = session;
            }
            $rootScope.session = SESSION;
            $rootScope.ob.session = SESSION;

            $rootScope.sessionLabel = ($rootScope.globalAttributes['co.obto.edu.session.label']) ? $rootScope.globalAttributes['co.obto.edu.session.label'] + " - " + $rootScope.ob.session : "Session" + " - " + $rootScope.ob.session;
            $rootScope.ob.sessionLabel = ($rootScope.globalAttributes['co.obto.edu.session.label']) ? $rootScope.globalAttributes['co.obto.edu.session.label'] + " - " + $rootScope.ob.session : "Session" + " - " + $rootScope.ob.session;

            let eduSession = {
                session: $rootScope.ob.session,
                sessionLabel: $rootScope.ob.sessionLabel
            };
            $localstorage.setObject("ob.edu", eduSession);
            $log.info("Session Saved.");
        }

    }])
    .service('ScriptLoader', ['$window', '$http', '$rootScope', '$localstorage', '$log', '$location', '$route', '$timeout', 'API', '$q', function ($window, $http, $rootScope, $localstorage, $log, $location, $route, $timeout, API, $q) {

        this.AllScripts = [];
        let loadDeferred = null;
        this.init = () => {

            let etag = $localstorage.get('csEtag');
            let deferred = $q.defer();
            // global.AgGridReact = AgGridReact;
            global.async = async;
            global.PropTypes = PropTypes;
            global.connect = connect;
            global.createStore = createStore;
            Object.assign(global, { Stepper, Step, Draggable, DraggableCore, saveAs, XLSX, StepWizard, ColumnSelect, Timeline, TimelineMarkers, TodayMarker, CustomMarker, CursorMarker, CheckboxTree, ReactDOM, React, NProgress, moment, uuidv4, _, swal, print });
            Object.assign(global, { markdownIt, HTMLEncode, hljs, fetchEventSource, DailyIframe, dco, RecoilRoot, antd, antdPlots, antdIcons, tus, loadStripe, antv, useSelector, useDispatch, http, MonacoEditor, Highcharts, HighchartsReact });

            const ob = {
                timeout: $timeout,
                http: $http,
                window: $window,
                moment: moment,
                API: API,
                localStorage: $localstorage,
                root: $rootScope,
                share: {},
                M: this,
                _,
                autobind: (self, options) => {

                    const excludedReactMethods = [
                        'componentWillMount',
                        'UNSAFE_componentWillMount',
                        'render',
                        'getSnapshotBeforeUpdate',
                        'componentDidMount',
                        'componentWillReceiveProps',
                        'UNSAFE_componentWillReceiveProps',
                        'shouldComponentUpdate',
                        'componentWillUpdate',
                        'UNSAFE_componentWillUpdate',
                        'componentDidUpdate',
                        'componentWillUnmount',
                        'componentDidCatch',
                        'setState',
                        'forceUpdate'
                    ];

                    options = Object.assign({}, options);
                    options.exclude = (options.exclude || []).concat(excludedReactMethods);

                    const filter = key => {
                        const match = pattern => typeof pattern === 'string' ? key === pattern : pattern.test(key);

                        if (options.include) {
                            return options.include.some(match);
                        }

                        if (options.exclude) {
                            return !options.exclude.some(match);
                        }

                        return true;
                    };

                    for (const key of Object.getOwnPropertyNames(self.constructor.prototype)) {
                        const value = self[key];

                        if (key !== 'constructor' && typeof value === 'function' && filter(key)) {
                            self[key] = value.bind(self);
                        }
                    }

                    return self;
                }
            };

            const req = {
                method: 'GET',
                url: '/fetches.bto'
            };
            if (etag) {
                req.headers = {
                    'If-None-Match': etag
                }
            }

            $http(req).then((response) => {

                if (response.status === 200 && response.data.length !== 0) {
                    $localstorage.set('csEtag', response.headers('ETag'));
                    this.AllScripts = response.data;
                    const allCSKeys = [];
                    async.eachSeries(response.data, (cl, cb) => {

                        if (!cl.compiled) {
                            return cb();
                        }
                        try {
                            $localstorage.set("cs-" + cl.name, cl.compiled.code);
                            this[cl.name] = new Function(`try { ${cl.compiled.code} return _func; } catch(e){ throw e;}`)()(ob);
                            Object.assign(global, this);
                            allCSKeys.push(cl.name);
                        } catch (e) {
                            console.log('Faulty CS..', cl.name);
                            // throw new Error(e);
                            console.error(e.message);
                        }
                        cb();
                    }, (err) => {
                        $localstorage.set('allCSKeys', allCSKeys);
                        deferred.resolve(this);
                    });

                } else {
                    $log.info("No Client Libraries Available");
                    deferred.reject(null);
                }

            }).catch(response => {
                console.log('Etag: ' + response.headers('ETag'), response.status);

                if (response.status === 304 || etag === response.headers('ETag')) {
                    const allCSKeys = $localstorage.get('allCSKeys').split(',');
                    console.log("Scripts not modified. Use cached version.");
                    async.eachSeries(allCSKeys, (csName, cb) => {
                        try {
                            const compiledCode = $localstorage.get("cs-" + csName);
                            this[csName] = new Function(`try { ${compiledCode} return _func; } catch(e){ throw e;}`)()(ob);
                            Object.assign(global, this);
                        } catch (e) {
                            console.log('Faulty Cached CS..', csName);
                            console.error(e.message);
                        }
                        cb();
                    }, (err) => {
                        deferred.resolve(this);
                    });
                }
            });

            loadDeferred = deferred;
            return deferred.promise; //Important

        };

        this.load = () => {
            if (this.AllScripts.length !== 0) {
                const self = this;
                return new Promise((resolve, rej) => {
                    resolve(self);
                });
            } else {
                if (loadDeferred) {
                    return loadDeferred.promise;
                } else {
                    return this.init();
                }
            }
        }

    }])
    // .service('ServerScriptLoader', ['$window', '$http', '$rootScope', '$localstorage', '$log', '$location', '$route', '$timeout', 'API', '$q', function ($window, $http, $rootScope, $localstorage, $log, $location, $route, $timeout, API, $q) {

    //     this.init = () => {

    //         let deferred = $q.defer();

    //         global.NProgress = NProgress;
    //         global.React = React;
    //         global.ReactDOM = ReactDOM;
    //         global.moment = moment;
    //         global.async = async;
    //         global._ = _;
    //         global.PropTypes = PropTypes;
    //         global.connect = connect;
    //         global.createStore = createStore;

    //         const ob = {
    //             timeout: $timeout,
    //             http: $http,
    //             window: $window,
    //             moment: moment,
    //             API: API,
    //             localStorage: $localstorage,
    //             share: {},
    //             M: this,
    //             autobind: (self, options) => {

    //                 const excludedReactMethods = [
    //                     'componentWillMount',
    //                     'UNSAFE_componentWillMount',
    //                     'render',
    //                     'getSnapshotBeforeUpdate',
    //                     'componentDidMount',
    //                     'componentWillReceiveProps',
    //                     'UNSAFE_componentWillReceiveProps',
    //                     'shouldComponentUpdate',
    //                     'componentWillUpdate',
    //                     'UNSAFE_componentWillUpdate',
    //                     'componentDidUpdate',
    //                     'componentWillUnmount',
    //                     'componentDidCatch',
    //                     'setState',
    //                     'forceUpdate'
    //                 ];

    //                 options = Object.assign({}, options);
    //                 options.exclude = (options.exclude || []).concat(excludedReactMethods);

    //                 const filter = key => {
    //                     const match = pattern => typeof pattern === 'string' ? key === pattern : pattern.test(key);

    //                     if (options.include) {
    //                         return options.include.some(match);
    //                     }

    //                     if (options.exclude) {
    //                         return !options.exclude.some(match);
    //                     }

    //                     return true;
    //                 };

    //                 for (const key of Object.getOwnPropertyNames(self.constructor.prototype)) {
    //                     const value = self[key];

    //                     if (key !== 'constructor' && typeof value === 'function' && filter(key)) {
    //                         self[key] = value.bind(self);
    //                     }
    //                 }

    //                 return self;
    //             }
    //         };

    //         $http.get('/fetches.bto').then((response) => {

    //             if (response.status === 200 || response.data.length !== 0) {

    //                 async.eachSeries(response.data, (cl, cb) => {

    //                     if (!cl.compiled) {
    //                         return cb();
    //                     }
    //                     // console.log(response.data[0].compiled.code);
    //                     try {
    //                         $localstorage.set("cs-" + cl.name, cl.compiled.code);
    //                         this[cl.name] = new Function(`try { ${cl.compiled.code} return _func; } catch(e){ throw e;}`)()(ob);
    //                         // console.log(this);
    //                     } catch (e) {
    //                         console.log('Faulty CS..', cl.name);
    //                         // throw new Error(e);
    //                         console.error(e.message);
    //                     }
    //                     cb();
    //                 }, (err) => {
    //                     deferred.resolve(this);
    //                 });

    //             } else {
    //                 $log.info("No Client Libraries Available");
    //                 deferred.reject(null);
    //             }

    //         });

    //         return deferred.promise; //Important

    //     };

    // }])
    .factory('loginInterceptor', ['$rootScope', '$q', '$window', '$location', '$localstorage', '$log', function ($rootScope, $q, $window, $location, $localstorage, $log) {
        return {
            request: function (config) {
                let USE_TOKEN = $localstorage.get("wsToken");
                const __ot = $localstorage.get("__ot");
                if (__ot) {
                    USE_TOKEN = __ot;
                }

                config.headers = config.headers || {};
                config.headers.SwitchUI = $rootScope.ob.user.newui;
                config.params = config.params || {};
                config.headers["Instance-Edu"] = $rootScope.ob.isEdu;
                config.headers["Current-Domain"] = $rootScope.ob.domain;
                config.headers["Current-Session"] = $localstorage.getObject("ob.edu").session || $rootScope.ob.session;

                if (USE_TOKEN) {
                    config.headers.Authorization = 'Bearer ' + USE_TOKEN;
                    if (!config.headers['x-access-token'] && !config.headers['X-ACCESS-TOKEN']) {
                        config.headers['x-access-token'] = USE_TOKEN;
                    }
                }

                const regex = /res.cloudinary.com/i;
                if (regex.test(config.url)) {
                    delete config.headers["Instance-Edu"];
                    delete config.headers["Current-Session"];
                    delete config.headers["Current-Domain"];
                    delete config.headers.Authorization;
                }
                return config;
            },
            response: function (responseData) {
                return responseData;
            },
            responseError: function (rejection) {

                if ([400, 404, 500, 502, 522, 524,].includes(rejection.status)) {
                    return rejection;
                }

                if (rejection.status === 401 && rejection.config.url !== "/ms/v2/initialize.bto") {
                    // $log.error("Login failed " + rejection.config.url);
                    let deferred = $q.defer();
                    let req = {
                        config: rejection.config,
                        deferred: deferred
                    };
                    // handle the case where the user is not authenticated
                    $rootScope.requests401.push(req);
                    $rootScope.ob.isLoginOpen = true;
                    if ($location.path() !== "/") {
                        $rootScope.redirectTo = $location.path();
                    }

                    if (rejection.config.url.startsWith('/o/ping')) {
                        $localstorage.remove("__ot");
                    }

                    $rootScope.$broadcast('event:loginRequired');

                    return deferred.promise;
                }

                if (rejection.status === 503) {
                    $log.info("Under Maintenance");
                    window.location = "/assets/dist/maintain.html?v=14.9.0";
                    return;
                }

                return $q.reject(rejection);
            }
        };
    }])
    .factory('syncFactory', ['$location', '$http', '$rootScope', '$q', '$log', 'scriptConsole', '$localstorage', '$timeout', '$sce', function ($location, $http, $rootScope, $q, $log, scriptConsole, $localstorage, $timeout, $sce) {

        let SYNCSERVICE = {};

        SYNCSERVICE.initiate = () => {
            let deferred = $q.defer(),
                initTimeout = $rootScope.globalAttributes['co.obto.websocket.connection.delay'] || 1500;

            $timeout(function () {

                if ('serviceWorker' in navigator) {

                    window.addEventListener('message', event => {
                        console.log(event);
                    }, false);

                    navigator.serviceWorker.addEventListener('message', function (event) {
                        // let data;
                        console.log("Message recieved in main app:", event);
                        // if (event.data) {
                        //     data = event.data;
                        //     if (data.property === "counter" && data.state !== undefined) {
                        //         setCounter(data.state, true);
                        //     }
                        // }
                    });

                    navigator.serviceWorker.register('/assets/dist/sw.js')
                        // .then(function () {
                        //
                        //     return navigator.serviceWorker.ready;
                        // })
                        .then(function (reg) {
                            // reg.update();
                            console.log('Service Worker is ready', reg);

                            setTimeout(() => {
                                // sendMessage({
                                //     topic: "initiation",
                                //     payload: {
                                //         user_name: $rootScope.ob.user.username,
                                //         password: $localstorage.getObject("ob").token
                                //     }
                                // });
                                reg.active.postMessage({
                                    topic: "initiation",
                                    payload: {
                                        user_name: $rootScope.ob.user.username,
                                        password: $localstorage.getObject("ob").token
                                    }
                                });
                            }, 5000);
                        })
                        .catch(function (error) {
                            console.log('Error : ', error);
                        });

                    // function sendMessage(message) {
                    //     navigator.serviceWorker.controller.postMessage(message);
                    // }
                }

                // initCounter();

                function initCounter() {

                    // We use localstorage but easily could use IndexDB!
                    var validStoredCounter = localStorage.getItem("counter") !== undefined &&
                        localStorage.getItem("counter") !== null &&
                        localStorage.getItem("counter") !== "NaN";

                    if (validStoredCounter) {
                        var count = parseInt(localStorage.getItem("counter"));
                        setCounter(count, false);
                    } else {
                        setCounter(0, false);
                    }

                    document.getElementById("increment").addEventListener("click", increment);
                    document.getElementById("decrement").addEventListener("click", decrement);

                }

                function decrement(event) {
                    var count = getCount() - 1;
                    setCounter(count, false);
                }

                function increment(event) {
                    var count = getCount() + 1;
                    setCounter(count, false);
                }

                function getCount() {
                    var count = parseInt(document.getElementById("counter").innerHTML);
                    if (!isNaN(count)) {
                        return count;
                    } else {
                        return 0;
                    }
                }

                function setCounter(count, fromOtherTab) {
                    document.getElementById("counter").innerHTML = parseInt(count);
                    if (!fromOtherTab) {
                        localStorage.setItem("counter", count);
                        stateToServiceWorker({ property: "counter", state: count });
                    }
                }

                function stateToServiceWorker(data) {
                    if (navigator.serviceWorker && navigator.serviceWorker.controller) {
                        navigator.serviceWorker.controller
                            .postMessage(data);
                    }
                }

                deferred.resolve({});

            }, initTimeout);

            return deferred.promise;
        };

        return SYNCSERVICE;

    }])
    // Using shared worker
    // .factory('socketFactory', ['$location', '$http', '$rootScope', '$q', '$log', 'scriptConsole', '$localstorage', '$timeout', '$sce', '$window', function ($location, $http, $rootScope, $q, $log, scriptConsole, $localstorage, $timeout, $sce, $window) {

    //     const SOCKETSERVICE = {};

    //     SOCKETSERVICE.initiate = () => {

    //         const logQ = async.priorityQueue(function (data, callback) {
    //             scriptConsole.set(data);
    //             callback();
    //         }, 3);

    //         logQ.drain = function () {
    //         };

    //         const presenceQ = async.queue(function (d, callback) {
    //             if (d.status === 0) {
    //                 $rootScope.$broadcast("event:SocketUserOffline", {user: d.user});
    //             }
    //             if (d.status === 1) {
    //                 $rootScope.$broadcast("event:SocketUserOnline", {user: d.user});
    //             }
    //             if (d.status === 2) {
    //                 $rootScope.$broadcast("event:SocketUserAway", {user: d.user});
    //             }
    //             if (d.status === 3) {
    //                 $rootScope.$broadcast("event:SocketUserDnD", {user: d.user});
    //             }
    //             setTimeout(callback, 50);
    //         }, 10);

    //         presenceQ.drain = function () {
    //         };

    //         const notifyMe = (message) => {
    //             $log.debug(message);
    //             if (typeof message.m === "undefined") {
    //                 return;
    //             }

    //             if (Notification.permission !== "granted") {
    //                 Notification.requestPermission();
    //             } else {
    //                 let notification = new Notification('Sofos', {
    //                     icon: message.dp,
    //                     body: message.m,
    //                 });

    //                 notification.onclick = function () {
    //                     // window.open("https://");
    //                 };

    //             }

    //             (function () {
    //                 let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    //                 link.type = 'image/x-icon';
    //                 link.rel = 'shortcut icon';
    //                 link.href = '/assets/dist/2.0/img/favicon-active.ico';
    //                 document.getElementsByTagName('head')[0].appendChild(link);
    //             })();

    //             $.notify({
    //                 icon: message.dp,
    //                 title: message.from_name,
    //                 message: message.m
    //             }, {
    //                 placement: {
    //                     from: "bottom",
    //                     align: "right"
    //                 },
    //                 allow_dismiss: false,
    //                 type: 'minimalist',
    //                 delay: 3500,
    //                 icon_type: 'image',
    //                 template: '<div data-notify="container" class="col-xs-11 col-sm-3 alert alert-{0}" role="alert">' +
    //                     '<img data-notify="icon" class="img-circle pull-left">' +
    //                     '<span data-notify="title">{1}</span>' +
    //                     '<span data-notify="message">{2}</span>' +
    //                     '</div>'
    //             });

    //             try {
    //                 $("#chat" + message.f).addClass('obchatflash');
    //                 $(".menu-notification-icon").css('color', "red");

    //                 let audio = document.getElementById("ob-notfication");
    //                 audio.play();
    //             } catch (e) {
    //                 $log.error(e);
    //             }

    //             if (!("Notification" in window)) {
    //                 alert("This browser does not support desktop notification");
    //             }

    //         };

    //         const handleChatMessages = (data) => {
    //             const msgconstruct = {
    //                 m: data.msg,
    //                 s: false,
    //                 tp: data.tp,
    //                 t: data.t,
    //                 n: data.from_name,
    //                 id: data.id,
    //                 dp: data.display_picture,
    //                 f: data.from
    //             };

    //             if (typeof $rootScope.ob.conversations[data.from] === "undefined") {
    //                 $rootScope.ob.conversations[data.from] = [];
    //             }

    //             $rootScope.ob.chatusers.map((val, key) => {

    //                 if (val["userid"] === data.from) {
    //                     val["last_message"] = data.msg;
    //                     val["last_message_timestamp"] = data.t;
    //                 }
    //             });

    //             let checkIfMessageIsOld = $rootScope.ob.conversations[data.from].filter((_val) => {
    //                 return _val.id === data.id;
    //             });

    //             if (checkIfMessageIsOld.length === 0) {
    //                 $rootScope.ob.conversations[data.from].push(msgconstruct);
    //                 notifyMe(msgconstruct);
    //             } else {
    //                 // client.publish('user/chat/' + $rootScope.socketNamespace, null, {retain: true});
    //             }

    //             if (!$rootScope.ob.activeconversation || $rootScope.ob.activeconversation !== data.from) {
    //                 $rootScope.ob.conversationAlerts[data.from] = {};
    //             }

    //             if (!$rootScope.ob.alert) {
    //                 $rootScope.ob.alert = true;
    //             }
    //             $rootScope.ob.updateScroll();
    //             $rootScope.ob.alertCount++;
    //             // $rootScope.$emit("event:RefreshUsers", {});
    //             // $timeout(() => {
    //             //     $rootScope.$apply();
    //             // }, 300);
    //         };

    //         const chatQ = async.priorityQueue(function (data, callback) {
    //             handleChatMessages(data);
    //             callback();
    //         }, 3);

    //         chatQ.drain = function () {
    //         };

    //         const deferred = $q.defer();

    //         const loadWorker = async () => {
    //             $log.info("Connecting to worker....");
    //             const worker = new SharedWorker('/assets/dist/sharedworker.js?v=' + new Date().getTime());
    //             worker.port.addEventListener("message", function (e) {
    //                 $timeout(function () {
    //                     if (e.data.type === 'console') {
    //                         logQ.push(e.data.payload, new Date().getTime(), function (err) {

    //                         });
    //                     }

    //                     if (e.data.type === 'chat') {
    //                         chatQ.push(e.data.payload, new Date().getTime(), function (err) {

    //                         });
    //                     }

    //                     if (e.data.type === 'presence') {
    //                         presenceQ.push(e.data.payload, function (err) {
    //                         });
    //                     }

    //                     if (e.data.type === 'error') {
    //                     }

    //                     if (e.data.type === 'killme') {
    //                         worker.terminate();
    //                         loadWorker();
    //                     }

    //                 }, 0);
    //             }, false);

    //             worker.port.addEventListener("error", function (e) {
    //                 $log.info("Terminating worker....", e);
    //             }, false);

    //             window.obworker = worker;

    //             if (!$rootScope.ob.socketEnabled) {
    //                 console.log("Socket services have been paused.");
    //                 return;
    //             }

    //             worker.port.start();
    //             $log.info("Initiating worker....");
    //             worker.port.postMessage({
    //                 type: 'url',
    //                 url: `${window.location.protocol}//${window.location.host}/`
    //             });
    //             worker.port.postMessage({
    //                 type: 'connect',
    //                 connect: true,
    //                 endpoint: $rootScope.globalAttributes['co.obto.websocket.endpoint'],
    //                 token: (!$localstorage.getObject("ob")) ? $rootScope.ob.token : $localstorage.getObject("ob").token,
    //                 namespace: $rootScope.socketNamespace.toString(),
    //                 isSecure: $rootScope.ob.socketSecured
    //             });

    //             const initTimeout = $rootScope.globalAttributes['co.obto.websocket.connection.delay'] || 1500;

    //             setTimeout(()=>{
    //                 deferred.resolve(worker);
    //             }, initTimeout);

    //         };

    //         loadWorker();

    //         return deferred.promise;
    //     };

    //     return SOCKETSERVICE;

    // }])
    .service('socketFactory', ['$location', '$http', '$rootScope', '$q', '$log', 'scriptConsole', '$localstorage', '$timeout', '$sce', '$window', '$ngRedux', function ($location, $http, $rootScope, $q, $log, scriptConsole, $localstorage, $timeout, $sce, $window, $ngRedux) {
        let self = this;
        this.nMID = null;
        let client = null;
        this.currentFlow = [];

        /**
         * This Web Worker logic will notify our application to ping our MQTT connection to keep it alive.
         *
         */
        function keepAlive() {
            const ctx = self;
            setInterval(() => {
                ctx.postMessage('keep-alive'); // will post to our application, doesn't need to be named 'keep-alive' can be anything
            }, 10000); // every 15 seconds
        }

        /**
        * Creates a web worker via blob (instead of file)
        *
        */
        function createWebWorker(func) {
            return new Worker(URL.createObjectURL(new Blob(["(" + func.toString() + ")()"], { type: 'text/javascript' })));
        }

        const messageQ = async.priorityQueue((data, callback) => {
            try {
                setTimeout(() => {
                    $ngRedux.dispatch({
                        type: data.queueType || 'SET_BROKER_LOG',
                        payload: {
                            message: data.msg,
                            time: new Date().getTime()
                        }
                    })
                    callback();
                }, 150);
            } catch (e) {

            }
        }, 1000);

        messageQ.drain = function () {
            // console.log('all items have been processed');
        };

        // create a queue object with concurrency 2
        const q = async.queue(function (d, callback) {
            if (d.status === 0) {
                $rootScope.$broadcast("event:SocketUserOffline", { user: d.user });
            }
            if (d.status === 1) {
                $rootScope.$broadcast("event:SocketUserOnline", { user: d.user });
            }
            if (d.status === 2) {
                $rootScope.$broadcast("event:SocketUserAway", { user: d.user });
            }
            if (d.status === 3) {
                $rootScope.$broadcast("event:SocketUserDnD", { user: d.user });
            }
            setTimeout(callback, 50);
        }, 20);

        q.drain = function () {
            // console.log('all items have been processed');
        };

        const notifyMe = (message) => {
            $log.debug(message);
            if (typeof message.m === "undefined") {
                return;
            }

            if (Notification.permission !== "granted") {
                Notification.requestPermission();
            } else {
                let notification = new Notification('Sofos', {
                    icon: message.dp,
                    body: message.m,
                });

                notification.onclick = function () {
                    // window.open("https://");
                };

            }

            (function () {
                let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                link.type = 'image/x-icon';
                link.rel = 'shortcut icon';
                link.href = '/assets/dist/2.0/img/favicon-active.ico';
                document.getElementsByTagName('head')[0].appendChild(link);
            })();

            $.notify({
                icon: message.dp,
                title: message.n,
                message: message.m
            }, {
                placement: {
                    from: "bottom",
                    align: "right"
                },
                allow_dismiss: false,
                type: 'minimalist',
                delay: 4000,
                icon_type: 'image',
                template: '<div data-notify="container" class="col-xs-11 col-sm-3 alert alert-{0}" role="alert">' +
                    '<img data-notify="icon" class="img-circle pull-left">' +
                    '<span data-notify="title">{1}</span>' +
                    '<span data-notify="message">{2}</span>' +
                    '</div>'
            });

            try {
                $("#chat" + message.f).addClass('obchatflash');
                $(".menu-notification-icon").css('color', "red");

                let audio = document.getElementById("ob-notfication");
                audio.play();
            } catch (e) {
                $log.error(e);
            }

            if (!("Notification" in window)) {
                alert("This browser does not support desktop notification");
            }

        };

        const handleChatMessages = (data) => {
            const msgconstruct = {
                m: data.msg,
                s: false,
                tp: data.tp,
                t: data.t,
                n: data.from_name,
                uid: data.uid,
                dp: data.display_picture,
                f: data.from
            };

            if (typeof $rootScope.ob.conversations[data.from] === "undefined") {
                $rootScope.ob.conversations[data.from] = [];
            }

            $rootScope.ob.chatusers.map((val, key) => {

                if (val["userid"] === data.from) {
                    val["last_message"] = data.msg;
                    val["last_message_timestamp"] = data.t;
                }
            });

            let checkIfMessageIsOld = $rootScope.ob.conversations[data.from].filter((_val) => {
                return _val.uid === data.uid;
            });

            if (checkIfMessageIsOld.length === 0) {
                $rootScope.ob.conversations[data.from].push(msgconstruct);
                notifyMe(msgconstruct);
            }

            if (!$rootScope.ob.activeconversation || $rootScope.ob.activeconversation !== data.from) {
                $rootScope.ob.conversationAlerts[data.from] = {};
            }

            if (!$rootScope.ob.alert) {
                $rootScope.ob.alert = true;
            }
            $rootScope.ob.updateScroll();
            $rootScope.ob.alertCount++;
        };

        const chatQ = async.priorityQueue(function (data, callback) {
            handleChatMessages(data);
            callback();
        }, 3);

        chatQ.drain = function () {
        };

        const reduceNoise = (id) => {
            if (this.currentFlow.length > 92) {
                this.currentFlow.shift();
            }

            if (this.currentFlow.includes(id)) {
                return false;
            }

            this.currentFlow.push(id);
            return true;
        };

        self.disconnect = function () {
            try {
                if ($window.client) {
                    $window.client.end();
                }
                if (client) {
                    client.end();
                }
            } catch (e) {

            }
        };

        // Handle multiple tabs
        $window.addEventListener('beforeunload', function () {
            $log.info('Unloading socker factory');
            self.disconnect();
        });

        const execute = (_nMID) => {
            this.nMID = Math.random().toString(16).substr(2, 8);
            let deferred = $q.defer();
            try {
                if ($window.client) {
                    $window.client.end();
                }
                if (client) {
                    client.end();
                }
            } catch (e) {

            }

            const socketUri = $rootScope.globalAttributes['co.obto.websocket.endpoint'];
            const socketUsername = $rootScope.globalAttributes['co.obto.broker.username'];
            const socketPassword = $rootScope.globalAttributes['co.obto.broker.password'];
            const socketPort = $rootScope.globalAttributes['co.obto.broker.port'] || 8884;
            const brokerProtocol = $rootScope.globalAttributes['co.obto.broker.protocol'] || 'wss';
            const brokerPath = $rootScope.globalAttributes['co.obto.broker.path'] || '/mqtt';
            client = mqtt.connect({
                host: socketUri,
                protocol: brokerProtocol,
                path: brokerPath,
                hostname: socketUri,
                port: socketPort,
                username: socketUsername,
                password: socketPassword,
                rejectUnauthorized: false,
                clean: true,
                clientId: `${$rootScope.ob.domain}_${$rootScope.socketNamespace.toString()}_${this.nMID}`,
                keepalive: 0,
                reconnectPeriod: 1000 * 10,
                protocolId: 'MQTT',
                protocolVersion: 4,
                connectTimeout: 60 * 1000
            });

            client.on('message', function (topic, message) {
                let data = "";
                if (message) {
                    try {
                        data = JSON.parse(message.toString());
                    } catch (e) {
                        console.log(message.toString(), topic);
                        console.error(e);
                        return;
                    }

                }

                if (!reduceNoise(data.uid)) {
                    return;
                }

                if (data.msg && data.msg.from && data.msg.from === $rootScope.socketNamespace) {
                    return;
                }

                if (topic.startsWith(`${$rootScope.ob.domain}/user/typing/${$rootScope.socketNamespace}`)) {
                    return;
                }

                if (topic.startsWith(`${$rootScope.ob.domain}/user/stoptyping/${$rootScope.socketNamespace}`)) {
                    return;
                }

                if (topic.startsWith(`${$rootScope.ob.domain}/user/chat/`)) {
                    chatQ.push(data, new Date().getTime(), function (err) {

                    });
                }

                if (topic.startsWith(`${$rootScope.ob.domain}/${$rootScope.socketNamespace}/app`)) {
                    $rootScope.$broadcast(`event:${topic}`, { payload: data.msg });
                }

                if (topic.indexOf("document/update") > -1) {
                    const event = `event:${topic}`;
                    $ngRedux.dispatch({
                        type: 'UPDATE',
                        payload: {
                            events: {
                                event,
                                data
                            }
                        }
                    });
                }

                if (topic.indexOf("document/insert") > -1) {
                }

                if (topic.indexOf("document/view") > -1) {
                    const event = `event:${topic}`;
                    $ngRedux.dispatch({
                        type: 'UPDATE',
                        payload: {
                            events: {
                                event,
                                data
                            }
                        }
                    });
                }

                if (topic.startsWith(`${$rootScope.ob.domain}/user/notificationpulldown/${$rootScope.socketNamespace}`)) {
                    $rootScope.$broadcast("event:Notificationpulldown", { notification: data.msg });
                }

                if (topic.startsWith(`${$rootScope.ob.domain}/user/notificationpullup/${$rootScope.socketNamespace}`)) {
                    $rootScope.$broadcast("event:Notificationpullup", { notification: data.msg });
                }

                if (topic.startsWith(`${$rootScope.ob.domain}/presence`)) {
                    if (data.msg !== $rootScope.socketNamespace) {
                        $log.debug('setting online status ' + data);
                        q.push({ user: data.msg, status: 1 }, function (err) {

                        });
                    }
                }

                if (topic.startsWith(`${$rootScope.ob.domain}/offline`) && data.msg !== $rootScope.socketNamespace) {
                    $log.debug('setting offline status');
                    q.push({ user: data.msg, status: 0 }, function (err) {

                    });
                }

                if (topic.startsWith(`${$rootScope.ob.domain}/away`) && data.msg !== $rootScope.socketNamespace) {
                    $log.debug('setting offline status');
                    q.push({ user: data.msg, status: 2 }, function (err) {

                    });
                }

                if (topic.startsWith(`${$rootScope.ob.domain}/donotdisturb`) && data.msg !== $rootScope.socketNamespace) {
                    $log.debug('setting offline status');
                    q.push({ user: data.msg, status: 3 }, function (err) {

                    });
                }

                if (topic.startsWith(`${$rootScope.ob.domain}/user/console/${$rootScope.socketNamespace}`)) {
                    data.queueType = 'SET_BROKER_LOG';
                    messageQ.push(data, new Date().getTime(), function (err) {

                    });
                }

                if (topic.startsWith(`${$rootScope.ob.domain}/user/console/admins`)) {
                    $log.info('Server response : ' + data);
                    data.queueType = 'SET_BROKER_LOG';
                    messageQ.push(data, new Date().getTime(), function (err) {

                    });
                }

                if (topic.startsWith(`${$rootScope.ob.domain}/app/devzone/admins`)) {
                    $log.info('Server response : ' + data);
                    data.queueType = 'SET_DEVZONE_MESSAGE';
                    messageQ.push(data, new Date().getTime(), function (err) {

                    });
                }

            });

            client.on('connect', () => {
                $log.info('connected');
                client.subscribe(`${$rootScope.ob.domain}/presence`);
                client.subscribe(`${$rootScope.ob.domain}/offline`);
                client.subscribe(`${$rootScope.ob.domain}/away`);
                client.subscribe(`${$rootScope.ob.domain}/donotdisturb`);

                client.subscribe(`${$rootScope.ob.domain}/user/chat/${$rootScope.socketNamespace}`, { qos: 1 }, (err, granted) => {
                    if (err) {
                        console.log(err);
                        return;
                    }
                    console.log(granted);
                });

                client.subscribe(`${$rootScope.ob.domain}/user/notificationpullup/${$rootScope.socketNamespace}`, { qos: 1 });
                client.subscribe(`${$rootScope.ob.domain}/user/notificationpulldown/${$rootScope.socketNamespace}`, { qos: 1 });
                client.subscribe(`${$rootScope.ob.domain}/user/console/${$rootScope.socketNamespace}`);
                if ($rootScope.ob.user.domain === "dev") {
                    client.subscribe(`user/console/admins`);
                }
                client.subscribe(`${$rootScope.ob.domain}/user/typing/${$rootScope.socketNamespace}`);
                client.subscribe(`${$rootScope.ob.domain}/user/stoptyping/${$rootScope.socketNamespace}`);
                client.subscribe(`${$rootScope.ob.domain}/user/global`);
                client.subscribe(`${$rootScope.ob.domain}/user/killsession`);
                // client.publish(`${$rootScope.ob.domain}/presence`, JSON.stringify({
                //     uid: uuidv4(),
                //     msg: $rootScope.socketNamespace
                // }), { qos: 0, properties: { messageExpiryInterval: 5000 } });
                $rootScope.connectionlost = false;
                $window.client = client;
                $ngRedux.dispatch({
                    type: 'SET_BROKER_LOG',
                    payload: {
                        message: "Console connected",
                        time: new Date().getTime()
                    }
                })
                deferred.resolve(client);
            });

            client.on('reconnect', () => {
                $log.info('Reconnecting...' + socketUri);
                // this.nMID = Math.random().toString(16).substr(2, 8);
            });

            client.on('disconnect', () => {
                $log.info('disconnect...');
            });

            client.on('offline', () => {
                $log.info('offline...');
            });

            client.on('end', () => {
                $log.info('end...');
            });

            client.on('error', function (error) {
                $log.error(error);
                $localstorage.remove("clientConnected");
            });

            client.on('close', () => {
                // clean up keep alive web worker scheduler
                $log.info('Client closing...');
                // try {
                //     this.keepAliveWorker.terminate();
                // } catch (e) {

                // }
            });

            this.keepAliveWorker = createWebWorker(keepAlive);
            // event listener for our Web Worker
            this.keepAliveWorker.addEventListener('message', (event) => {
                // ping our mqtt connection to keep it alive
                try {
                    client._sendPacket({ cmd: 'pingreq' });
                } catch (e) {
                    console.log("Connection not ready yet.");
                }
            });

            return deferred.promise;
        };

        const doSomething = () => {
            // try {
            //     $window.client.publish(`${$rootScope.ob.domain}/presence`, JSON.stringify({
            //         uid: uuidv4(),
            //         msg: $rootScope.socketNamespace
            //     }));
            // } catch (e) {
            //     $log.error(e);
            // }
        };

        this.initiate = () => {
            if ($rootScope.ob.socketEnabled) {
                execute().then(() => {
                    $log.info('Connection confirmed');
                    $ngRedux.dispatch({
                        type: 'LOGIN',
                        payload: {
                            "loginStatus": 1,
                            "socketStatus": {
                                "status": "ready"
                            }
                        }
                    });
                    $ngRedux.dispatch({
                        type: 'CONNECTED'
                    });
                });
            }
        };

    }])
    .service('scriptConsole', ['$rootScope', '$ngRedux', function ($rootScope, $ngRedux) {
        // let message = {
        //     txt: "",
        //     time: new Date().getTime()
        // };

        // this.set = function (d) {
        //     if (typeof message && message.hasOwnProperty(txt)) {
        //         message.txt = d;
        //         message.time = new Date().toISOString();
        //         $rootScope.$digest();
        //         $ngRedux.dispatch({
        //             type: 'SET_BROKER_LOG',
        //             payload: `${message.time} - ${message.txt}`
        //         })
        //     }
        // };

        // this.getData = function () {
        //     return message;
        // };
    }])
    .factory('CalendarEvent', ['$resource', '$rootScope', function ($resource, $rootScope) {
        return $resource('/o/recs/calendar_event?oquery=user.value=$or' + $rootScope.ob.user.userid + '^global&stream=true&project=', {
            _id: '@id'
        });
    }])
    // .factory('ClassSchedule', ['$resource', '$rootScope', '_', function ($resource) {
    //     return $resource('/o/recs/class_schedule?nd=${new Date().getTime()}&stream=true&project=period,name,subject,day', {});
    // }])
    // .factory('Classes', ['$resource', function ($resource) {
    //     return $resource('/o/recs/class', {});
    // }])
    .factory('FetchRemote', ['$resource', function ($resource) {
        return $resource('/api/v2/fetch_remote_content.bto?id=:document_id&name=:name&collection=:collection');
    }])
    .factory('API', ['$resource', function ($resource) {
        return function (collection) {
            return $resource('/o/recs/' + collection);
        };
    }])
    .factory('ChatUsers', ['$resource', function ($resource) {
        return $resource('/getchatusers');
    }])
    .factory('ChatGroups', ['$resource', function ($resource) {
        return $resource('/getchatgroups');
    }]);
